<template>
	<div v-if="isScrollable === true && hasReachedBottom === false" class="scrollable-overlay" :class="{white}" :style="`bottom: ${bottom}`"></div>
</template>

<script>
import { arrowUp, arrowDown } from 'ionicons/icons'

export default {
	props: {
		bottom: {
			type: String,
			default: '0px'
		},

		isScrollable: {
			type: [Boolean, null],
			default: null
		},

		hasReachedBottom: {
			type: [Boolean, null],
			default: null
		},

		white: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			icons: {
				arrowUp,
				arrowDown
			}
		}
	}
}

</script>

<style lang="sass" scoped>
.scrollable-overlay
	@apply fixed left-[50%] -translate-x-1/2 bg-gradient-to-b from-transparent to-[--ion-color-light] h-[100px] w-full pointer-events-none z-50

	&.white
		@apply to-[#ffffff]
</style>